import { DATE_FORMAT } from '@yarmill/const';
import moment from 'moment';

export function getIndexForDate(date: string | moment.Moment): number {
  const momentDate =
    typeof date === 'string' ? moment(date, DATE_FORMAT) : date;
  return momentDate.isoWeekday() - 1; // we want monday to be 0
}
